








































import { AuthFactory } from "@/shared/api/auth";
import { Vue, Component } from "@/shared/vuepack";
import MetricTabsWithContent from "@/employer/components/metric/MetricTabsWithContent.vue";
import MetricTabs from "@/employer/components/metric/MetricTabs.vue";
import { withTableauDashboards } from "@/employer/utilities/withTableauDashboards";
import Button from "@/shared/components/ui/Button.vue";
import * as RouteNames from "@/employer/route-names";
import { useUserStore } from "@/shared/store/user";
import { Config } from "@/shared/config";

@Component({
  components: {
    MetricTabsWithContent,
    MetricTabs,
    Button,
  }
})
export default class DashboardMetrics extends Vue {
  accessToken = AuthFactory.getAuth().accessToken();
  userStore = useUserStore();
  programSnapshotMetrics: any[] = [];
  companyMetrics: any[] = [];

  programSnapshotSelectors = ["HSA-ProgramSnapshot", "FSA-ProgramSnapshot", "Commuter-ProgramSnapshot", "HRA-ProgramSnapshot"];
  companyMetricsSelectors = ["HSA-Accounts-CompanyMetrics", "Balance-tiers-CompanyMetrics", "Balances-CompanyMetrics", "Velocity-CompanyMetrics"];

  async created () {
      this.programSnapshotMetrics = await this.userStore.getMetricsWithContent(this.programSnapshotSelectors);
      this.companyMetrics = await this.userStore.getMetricsWithContent(this.companyMetricsSelectors);
  }

  mounted () {
    withTableauDashboards (Config.UserServicebaseUri);
  }

  openLink () {
    this.$router.push({ name: RouteNames.ProgramHealth });
  }

  get employerCode (): string {
    return this.userStore.currentEmployer.wexEmployerCode;
  }
}
